// The segmented pill shared by Monthly | Total (Holding Costs spec 1.3) and Timeline's Projected | Actual
// (letter 122 item 3): track h26 rx6 #EEF3EC, a white rx5 thumb 1px inside under the selected segment,
// labels 13/600 centred in their segment, selected #4AA52A. Track width = segments + 2.
const TRACK_CLS = 'relative h-[26px] rounded-[6px] bg-[#EEF3EC] hover:bg-[#DDE9D8] shrink-0'
const THUMB_CLS = 'absolute top-[1px] h-[24px] rounded-[5px] bg-white transition-[left,width]'
const LABEL_CLS =
  'relative z-10 h-[24px] mt-[1px] text-[13px] font-semibold text-center leading-[24px] rounded-[5px] outline-none focus-visible:ring-2 focus-visible:ring-brand-green'

// `options`: [{ value, label, width }], left to right. `selected` is the value of the selected option.
// No option is a Tab stop (letter 111, CS#3 item 5: Tab walks the input fields only).
export default function PillToggle({ options, selected, onChange, ariaLabel }) {
  const index = Math.max(0, options.findIndex((o) => o.value === selected))
  const thumbLeft = 1 + options.slice(0, index).reduce((sum, o) => sum + o.width, 0)
  const trackWidth = options.reduce((sum, o) => sum + o.width, 0) + 2

  return (
    <div className={TRACK_CLS} style={{ width: trackWidth }} role="radiogroup" aria-label={ariaLabel}>
      <div className={THUMB_CLS} data-testid="pill-thumb" style={{ left: thumbLeft, width: options[index].width }} />
      <div className="relative flex pl-[1px]">
        {options.map((o, i) => (
          <button
            key={o.value}
            type="button"
            role="radio"
            tabIndex={-1}
            aria-checked={i === index}
            onClick={() => onChange(o.value)}
            className={`${LABEL_CLS} ${i === index ? 'text-[#4AA52A]' : 'text-brand-dark'}`}
            style={{ width: o.width }}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  )
}
